<template>

  <div class="max-w-lg w-full mx-auto">
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
      <div class="mt-8 mx-auto max-w-7xl px-4 sm:mt-4 sm:px-6">
        <div class="text-center">
          <h1
            class="
             text-2xl tracking-tight font-black text-gray-900 sm:text-3xl"
          >
            <span>Get your </span>
            <span class="text-mygrad">Personalised GraduationClip</span>
          </h1>

          <p
            class="
             mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl"
          >
            Graduation day at <b>{{ organiserName }}</b> is an important moment to
            celebrate, and we know you're ready to share it with the world!
          </p>
          <p
            v-if="organiserSlug == 'bristol' || organiserSlug == 'ulster' || organiserSlug == 'city-london'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            Watch a sample GraduationClip.
          </p>
           <div
            v-if="organiserSlug == 'murdoch'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/1163493835?h=a6c0832659&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'anu'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/1159026256?h=5b386f2900&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'ecu'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/1162475494?h=b572a97467&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'bristol'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/719163247?h=5e84a744e0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'ulster'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/778964708?h=1e06115b45&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'adelaide'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              
              <iframe
                src="https://player.vimeo.com/video/1140731221?h=07a3c62392&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'queensland'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              
              <iframe
                src="https://player.vimeo.com/video/1145368013?h=506c65d274&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'cdu'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              
              <iframe
                src="https://player.vimeo.com/video/1118849020?h=ee31972ea4&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'torrens'"
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              
              <iframe
                src="https://player.vimeo.com/video/1127433459?h=40d9b7552b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'city-london'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/904145077?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
           <div
            v-if="organiserSlug == 'flinders'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/1147114324?h=9125eb1dc5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <div
            v-if="organiserSlug == 'roehampton'"
            class="
               mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                src="https://player.vimeo.com/video/908149069?h=d839a73f66&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="MyGraduationClip"
              ></iframe>
            </div>
          </div>
          <button
            type="submit"
            @click="$emit('submit', form)"
            class="
             inline-flex mt-3 items-center justify-center w-full px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
          >
            Order your GraduationClip now
          </button>

          <p
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            We're excited to introduce our new GraduationClip - a
            <b>short video of your graduation ceremony</b> that you can share on
            social media, or keep on hand to relive your special moment whenever
            you want.
          </p>

          <p
            class="
             mt-6 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            You'll get a link in your email after the ceremony, so you can post
            it online and share all the fun details of your big day with
            everyone who couldn't be there. We hope this will help you relive
            the magic of your graduation celebration every time you watch it!
          </p>
          <button v-if="organiserSlug == 'bristol'"
            type="submit"
            @click="$emit('submit', form)"
            class="
              inline-flex mt-3 items-center px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
          >
            Buy now - £10
          </button>
          <button v-else-if="organiserSlug == 'ulster'"
            type="submit"
            @click="$emit('submit', form)"
            class="
              inline-flex mt-3 items-center px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
          >
            Buy now - £15
          </button>
          <button v-else-if="organiserSlug == 'city-london'"
            type="submit"
            @click="$emit('submit', form)"
            class="
              inline-flex mt-3 items-center px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
          >
            Buy now - £20
          </button>
           <button v-else
            type="submit"
            @click="$emit('submit', form)"
            class="
              inline-flex mt-3 items-center px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
          >
            Buy now
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "IndividualSalesPage",
  props: { title: String, organiserName: String, organiserSlug: String},
  data: function () {
    return {
      form: {
        name: "",
      },
    };
  },
  methods: {
    submit() {
      this.$emit("submit", this.form);
    },
  },
};
</script>
